import { siteConfig } from '../../config/site';
import { ProjectInquiryForm } from '../../features/project-inquiry/ProjectInquiryForm';
import { buildWhatsAppUrl } from '../../lib/whatsapp';
import { ButtonLink } from '../ui/ButtonLink';
import { Reveal } from '../ui/Reveal';

export function ProjectInquirySection() {
  return (
    <section className="section project-inquiry-section" id="project-inquiry">
      <div className="shell project-inquiry-section__grid">
        <div className="project-inquiry-section__intro"><Reveal>
          <p className="eyebrow">Project Inquiry</p>
          <h2>Have a project in mind?</h2>
          <p>Tell me what you're building and I'll reply with the next steps, scope questions and a starting estimate.</p>
          <div className="project-inquiry-section__alternate">
            <span>Prefer messaging?</span>
            <ButtonLink href={buildWhatsAppUrl(siteConfig.defaultWhatsAppMessage)} variant="secondary">Chat on WhatsApp</ButtonLink>
          </div>
        </Reveal></div>
        <Reveal className="project-inquiry-section__form" delay={0.09}><ProjectInquiryForm id="homepage-project-inquiry" /></Reveal>
      </div>
    </section>
  );
}
